import { render } from "./DrugstoreGroupsList.vue?vue&type=template&id=63d0a08d&scoped=true"
import script from "./DrugstoreGroupsList.vue?vue&type=script&lang=js"
export * from "./DrugstoreGroupsList.vue?vue&type=script&lang=js"

import "./DrugstoreGroupsList.vue?vue&type=style&index=0&id=63d0a08d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63d0a08d"]])

export default __exports__